module.exports = __webpack_public_path__ + "img/deliveries.ff785f3a.png";